import { HttpApiEndpoint, HttpApiGroup, OpenApi } from 'effect/http-api';
import { Schema } from 'effect';
import { InternalServerError } from './errors';
import { ClientFlagValues } from './flags';
import { OptionalUserAuthMiddleware } from './middleware';

export const FlagsResponse = Schema.Struct({
  /** The signed-in user the values were decided for; `null` when signed out. */
  userId: Schema.NullOr(Schema.String),
  flags: ClientFlagValues,
});
export type FlagsResponse = typeof FlagsResponse.Type;

const getFlagsEndpoint = HttpApiEndpoint.get('Get', '/', {
  success: FlagsResponse,
  error: InternalServerError,
})
  .middleware(OptionalUserAuthMiddleware)
  .annotate(OpenApi.Summary, 'Feature flag values for the current viewer')
  .annotate(
    OpenApi.Description,
    "The requesting app's flags from `@listening/api-contract/flags` (mobile " +
      'requests send a `platform` header; others are web), decided for the ' +
      'signed-in user, or for the anonymous PostHog id in the cookie. Values ' +
      'are keyed by flag name; read each with the client flag readers.',
  );

export const flagsGroup = HttpApiGroup.make('Flags')
  .add(getFlagsEndpoint)
  .prefix('/flags');
